module.exports = __webpack_public_path__ + "img/1f526.5a95853.svg";